import { Pipe, PipeTransform } from '@angular/core';
import * as marked from 'marked';
import * as DOMPurify from 'dompurify';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'markdown',
})
export class MarkdownPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
    marked.setOptions({
      gfm: true,
      breaks: true,
      smartLists: true,
      smartypants: true,
    });
  }

  public transform(value: string): SafeHtml {
    const dirty = marked(value || '');
    const clean = DOMPurify.sanitize(dirty);
    return this.sanitizer.bypassSecurityTrustHtml(clean);
  }
}
